'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');

exports.default = {
  props: {
    listArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemIndex: {
      type: Number,
      default: null
    },
    wrapHeight: {
      type: Number,
      default: 350
    },
    wrapWidth: {
      type: Number,
      default: 750
    },
    isShowIndicator: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    labelOffset: {
      type: Number,
      default: null
    },
    align: {
      type: String,
      default: 'center' // 'center'/'left'
    }
  },
  computed: {
    wrapStyle: function wrapStyle() {
      return {
        width: this.wrapWidth,
        height: this.wrapHeight
      };
    },
    selectedItemTop: function selectedItemTop() {
      return Math.floor(this.wrapHeight / this.itemHeight / 2) * this.itemHeight;
    },
    indicatorStyle: function indicatorStyle() {
      return {
        top: this.selectedItemTop + 'px',
        width: this.wrapWidth,
        height: this.itemHeight + 2
      };
    },
    labelStyle: function labelStyle() {
      return {
        top: this.selectedItemTop + 'px',
        left: this.labelOffset ? this.labelOffset : this.wrapWidth / 2 + 50,
        width: this.wrapWidth / 2,
        height: this.itemHeight
      };
    },
    scrollerStyle: function scrollerStyle() {
      return {
        width: this.wrapWidth,
        height: this.wrapHeight
      };
    },
    itemStyle: function itemStyle() {
      return {
        width: this.wrapWidth
      };
    },
    calcListArray: function calcListArray() {
      var _this = this;

      var result = [];
      result = this.listArray.map(function (item, index) {
        item['classes'] = [];
        if (_this.align == 'left' && _this.label) {
          item['classes'].push('list-item-left');
        }
        if (index == 0) {
          item['classes'].push('first-item');
        } else if (index == _this.listArray.length - 1) {
          item['classes'].push('last-item');
        }

        if (index == _this.itemIndex - 2) {
          item['classes'].push('first-visible-item');
        } else if (index == _this.itemIndex - 1) {
          item['classes'].push('second-visible-item');
        } else if (index == _this.itemIndex) {
          item['classes'].push('selected-item');
        } else if (index == _this.itemIndex + 1) {
          item['classes'].push('second-last-visible-item');
        } else if (index == _this.itemIndex + 2) {
          item['classes'].push('first-last-visible-item');
        }

        return item;
      });

      return result;
    }
  },
  data: function data() {
    return {
      isInit: false,
      itemHeight: 70,
      index: this.itemIndex,
      handler: null,
      intervalHandler: null
    };
  },

  watch: {
    itemIndex: function itemIndex(value) {
      this.index = value;
    }
  },
  methods: {
    scroll: function scroll(event) {
      var _this2 = this;

      if (!this.isInit) return;
      // 计算当前滚动到的下标
      this.itemIndex = Math.abs(Math.round((event.contentOffset.y || 0) / this.itemHeight));
      // 处理滚动超过边界时，不触发scrollEnd的问题 2019-08-02 Ken Added Start***
      if (weex.config.env.platform == 'android') {
        if (this.handler) {
          clearTimeout(this.handler);
        }
        this.handler = setTimeout(function () {
          _this2.handleEnd(event);
        }, 500);
      }
      // 处理滚动超过边界时，不触发scrollEnd的问题 2019-08-02 Ken Added End***
    },
    handleEnd: function handleEnd(e) {
      var _this3 = this;

      if (!this.isInit) return;
      // 计算当前滚动到的下标
      setTimeout(function () {
        _this3.scrollToIndexItem(_this3.itemIndex);
        _this3.$emit('onChange', _this3.listArray[_this3.itemIndex]);
      }, 400);
    },
    scrollToIndexItem: function scrollToIndexItem(index) {
      var _this4 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var el = this.$refs.item[index];
      if (el) {
        dom.getComponentRect(el, function (options) {
          if (options.result && options.size.bottom) {
            dom.scrollToElement(el, { animated: animated, offset: index == 0 ? 0 : -_this4.selectedItemTop });
            _this4.isInit = true;
          } else {
            setTimeout(function () {
              return _this4.scrollToIndexItem(index, animated);
            }, 100);
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.itemIndex != null) {
      this.scrollToIndexItem(this.itemIndex, false);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-scroll-picker/index.vue
// module id = 386
// module chunks = 0 1